module.exports = __webpack_public_path__ + "static/media/hero-studio-alto_2880x2160.db72a9d7.jpg";